import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import * as ProgramTemplatesApi from "../api/programTemplatesApi";

export const loadProgramTemplates = createAsyncThunk(
  "programTemplates/loadProgramTemplates",
  (args) => ProgramTemplatesApi.loadProgramTemplatesWithCache.call(args)
);

export const loadProgramTemplatesForCurrentUser = createAsyncThunk(
  "foods/loadProgramTemplatesForCurrentUser",
  (args) =>
    ProgramTemplatesApi.loadProgramTemplatesForCurrentUserWithCache.call(args)
);

export const loadCurrentProgramTemplate = createAsyncThunk(
  "programTemplates/loadCurrentProgramTemplate",
  (args) => ProgramTemplatesApi.loadCurrentProgramTemplateWithCache.call(args)
);

export const addProgramTemplate = createAsyncThunk(
  "programTemplates/addProgramTemplate",
  ProgramTemplatesApi.addProgramTemplate
);

export const editProgramTemplate = createAsyncThunk(
  "programTemplates/editProgramTemplate",
  ProgramTemplatesApi.editProgramTemplate
);

export const deleteProgramTemplate = createAsyncThunk(
  "programTemplates/deleteProgramTemplate",
  ProgramTemplatesApi.deleteProgramTemplate
);

const programTemplatesSlice = createSlice({
  name: "programTemplates",
  initialState: {
    items: null,
    item: null,
    itemCurrentUser: null,
    itemForDelete: null,
    loading: false,
    saving: false,
    success: false,
    error: "",
    changeAllExercise: true,
    selectedExercise: null,
    selectedExerciseDayIdx: null,
    selectedExerciseWorkoutIdx: null,
    selectedExerciseIdx: null,
    successfullyAddTemplate: false,
    successfullyDeleteTemplate: false,
    exerciseSetErrors: {},
    history: [],
  },
  reducers: {
    clearStatuses(state) {
      state.success = false;
      state.successfullyAddTemplate = false;
    },
    clearError(state) {
      state.error = "";
    },
    clearSuccess(state) {
      state.success = false;
    },
    clearSuccessfullyAddTemplate(state) {
      state.successfullyAddTemplate = false;
    },
    clearSuccessfullyDeleteTemplate(state) {
      state.successfullyDeleteTemplate = false;
    },
    setItemForDelete(state, action) {
      state.itemForDelete = action.payload;
    },
    clearItemForDelete(state) {
      state.itemForDelete = null;
    },
    clearProgramTemplates(state) {
      state.templates = null;
    },
    setChangeAllExercise(state, action) {
      state.changeAllExercise = action.payload;
    },
    setSelectedExercise(state, action) {
      state.selectedExercise = action.payload?.data;
      state.selectedExerciseDayIdx = action.payload?.dayIdx;
      state.selectedExerciseWorkoutIdx = action.payload?.workoutIdx;
      state.selectedExerciseIdx = action.payload?.exerciseIdx;
    },
    setExerciseSetErrors(state, action) {
      state.exerciseSetErrors[JSON.stringify(action.payload)] = action.payload;
    },
    removeExerciseSetErrors(state, action) {
      delete state.exerciseSetErrors[JSON.stringify(action.payload)];
    },
    clearExerciseSetErrors(state) {
      state.exerciseSetErrors = {};
    },
    setHistory(state, action) {
      state.history = action.payload;
    },
  },
  extraReducers: {
    [loadProgramTemplates.pending]: (state) => {
      state.loading = true;
    },
    [loadProgramTemplates.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = "";
      state.items = action.payload;
    },
    [loadProgramTemplates.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [loadProgramTemplatesForCurrentUser.pending]: (state) => {
      state.loading = true;
    },
    [loadProgramTemplatesForCurrentUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = "";
      state.itemCurrentUser = action.payload;
    },
    [loadProgramTemplatesForCurrentUser.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [loadCurrentProgramTemplate.pending]: (state) => {
      state.loading = true;
    },
    [loadCurrentProgramTemplate.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = "";
      state.item = action.payload;
    },
    [loadCurrentProgramTemplate.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    [editProgramTemplate.pending]: (state) => {
      state.saving = true;
    },
    [editProgramTemplate.fulfilled]: (state, action) => {
      state.saving = false;
      state.success = true;
      state.error = "";
      state.item = action.payload;
    },
    [editProgramTemplate.rejected]: (state, action) => {
      state.saving = false;
      state.success = false;
      state.error = action.payload;
    },

    [addProgramTemplate.pending]: (state) => {
      state.loading = true;
    },
    [addProgramTemplate.fulfilled]: (state) => {
      state.loading = false;
      state.successfullyAddTemplate = true;
      state.error = "";
    },
    [addProgramTemplate.rejected]: (state, action) => {
      state.loading = false;
      state.successfullyAddTemplate = false;
      state.error = action.payload;
    },

    [deleteProgramTemplate.pending]: (state) => {
      state.isDeleting = true;
    },
    [deleteProgramTemplate.fulfilled]: (state) => {
      state.isDeleting = false;
      state.successfullyDeleteTemplate = true;
      state.error = "";
    },
    [deleteProgramTemplate.rejected]: (state, action) => {
      state.isDeleting = false;
      state.successfullyDeleteTemplate = false;
      state.error = action.payload;
    },
  },
});

export const {
  clearStatuses,
  clearError,
  clearSuccess,
  clearSuccessfullyAddTemplate,
  clearSuccessfullyDeleteTemplate,
  clearProgramTemplates,
  setItemForDelete,
  clearItemForDelete,
  setChangeAllExercise,
  setSelectedExercise,
  setExerciseSetErrors,
  removeExerciseSetErrors,
  clearExerciseSetErrors,
  setHistory,
} = programTemplatesSlice.actions;
export default programTemplatesSlice.reducer;
